import { apiMipe } from '@/core/api/';

export default {
  //ECG:filters contiene {name:'nombredefiltro', value:'valordelfiltro'}
  async getRolesSearchResults(filters, pageNumber, pageSize) {
    try {
      let searchText = filters.find((e) => e.name == 'textFilter');
      let appId = filters.find((e) => e.name == 'appIdFilter');

      const { data } = await apiMipe.get(
        '/api/roles?' +
          'filterCriteria=' +
          (searchText ? searchText.value : '') +
          '&appId=' +
          (appId ? appId.value : '') +
          '&pageNumber=' +
          pageNumber +
          '&pageSize=' +
          pageSize
      );
      return data;
    } catch (error) {
      return [];
    }
  },

  getStudentAddress: (studentSieId) => apiMipe.get(`/api/student/address/${studentSieId}`),

  async getUserProfile(userId, selectedRoleId, selectedRoleAccessLevel) {
    try {
      const { data } = await apiMipe.get('/api/userprofiles', {
        params: { userId, selectedRoleId, selectedRoleAccessLevel },
      });
      return data;
    } catch (error) {
      return error;
    }
  },

  async createUserProfile(profileData) {
    try {
      return apiMipe.post('/api/userprofiles', profileData);
    } catch (error) {
      return error;
    }
  },

  async updateUserProfile(profileData) {
    try {
      return apiMipe.put('/api/userprofiles', profileData);
    } catch (error) {
      return error;
    }
  },

  async getJobPositionsKeyValue() {
    try {
      //ECG:9 = EduEspPosition en enum de codetypes en EDUESP_Code
      return await apiMipe.get('/api/code/geteduespcodes', {
        params: { codeType: 9 },
      });
    } catch (error) {
      return error;
    }
  },

  async getServiceCentersKeyValue() {
    try {
      return await apiMipe.get('/api/location/allcenters');
    } catch (error) {
      return error;
    }
  },

  async getRoles() {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/roles');
      return data;
    } catch (error) {
      return [];
    }
  },

  async getRegions() {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/regions');
      return data;
    } catch (error) {
      return [];
    }
  },

  async getMunicipalities(params) {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/municipalities', {
        params,
      });
      return data;
    } catch (error) {
      return [];
    }
  },

  async getSchools(params) {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/schools', {
        params,
      });
      return data;
    } catch (error) {
      return [];
    }
  },

  async getDistricts() {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/districts');
      return data;
    } catch (error) {
      return [];
    }
  },

  async getCompanies(roleId) {
    try {
      const { data } = await apiMipe.get(
        `/api/userprofiles/companies/${roleId}`
      );
      return data;
    } catch (error) {
      return [];
    }
  },
  async getLocations(companyId) {
    try {
      const { data } = await apiMipe.get(
        `/api/userprofiles/locations/${companyId}`
      );
      return data;
    } catch (error) {
      return [];
    }
  },
  async getHealthRegions() {
    try {
      const { data } = await apiMipe.get('/api/userprofiles/healthregions');
      return data;
    } catch (error) {
      return [];
    }
  },
  saveParentProfileInformation(userId, studentSieIds) {
    return apiMipe.post(
      `/api/userprofiles/saveparentprofileinformation/${userId}`,
      studentSieIds
    );
  },
  async getParentProfileInformation(userId) {
    const { data } = await apiMipe.get(
      `/api/userprofiles/getparentprofileinformation/${userId}`
    );
    return data;
  },
  async getBasicStudentInformation(studentSieIdOrRegNumber) {
    const { data } = await apiMipe.get(
      `/api/userprofiles/basicstudentinfo/${studentSieIdOrRegNumber}`
    );
    return data;
  },

  async getCaat() {
    const { data } = await apiMipe.get(`/api/caats/getallcaats`);
    return data;
  },
};
